module.exports = __webpack_public_path__ + "static/media/nogal_rojo.32f6cc02.jpg";